<div class="project-modal">

  <!-- Header -->
  <div class="row align-items-center">
    <div class="col">
      <h3 class="text-manax m-0 mb-4 d-flex justify-content-between align-items-center">
        <!-- Título a la izquierda -->
        <span class="text-purple-manax text-capitalize title-modal">
          <span>{{ action }}</span> Proyecto
        </span>
        <!-- Botón de cierre a la derecha -->
        <span>
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
      </h3>
    </div>
  </div>


  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <div class="col-11">
            <mat-form-field appearance="outline">
              <mat-label>
                Cliente
                <span *ngIf="!(clientsTerm?.length || f['client']?.value)">(Escribe para buscar...)</span>
              </mat-label>
              <input type="text" matInput name="client" formControlName="client" [matAutocomplete]="autoClient"
                [readonly]="readOnly" (optionSelected)="onClientSelectionChange()">
              <mat-autocomplete #autoClient="matAutocomplete" [displayWith]="displayClientsFn" required>
                <mat-option *ngFor="let client of $clients | async" [value]="client">
                  {{client.firstname}} {{client.lastname ? client.lastname : ''}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-error *ngIf="submitted && f['client']?.errors?.['required']">
              Cliente Obligatorio
            </mat-error>
            <mat-error *ngIf="submitted && f['client']?.errors?.['notFound']">
              Cliente NO Encontrado (Agregar Nuevo?)
            </mat-error>
          </div>
          <div class="col-1 pt-2 pl-0">
            <button type="button" class="btn btn-manax m-0 p-2" (click)="openNewClientModal()">
              <i class="material-icons">add</i>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Nombre del Proyecto </mat-label>
              <input matInput name="name" formControlName="name" [readonly]="readOnly" required>
            </mat-form-field>
            <mat-error *ngIf="submitted && f['name']?.errors?.['required']">
              Nombre del Proyecto Obligatorio
            </mat-error>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Descripción del Proyecto </mat-label>
              <textarea matInput formControlName="description" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5">
                  </textarea>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Fecha Inicio </mat-label>
              <input matInput name="startDate" formControlName="startDate" class="d-flex" style="line-height: 11px;"
                type="date" #dobInput [readonly]="readOnly">
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Fecha Fin </mat-label>
              <input matInput name="endDate" formControlName="endDate" class="d-flex" style="line-height: 11px;"
                type="date" #dobInput [readonly]="readOnly">
            </mat-form-field>
          </div>
        </div>

        <div class="row font-manax py-3">
          <div class="col-12">
            <h5 class="m-0 title-section">
              Gastos
            </h5>
          </div>

          <div class="col-12">
            <app-detail-list-expenses [items]="project.expenses || []" (listChange)="onListChangeExpenses($event)"
              [readOnly]="false" [pricing]="true"></app-detail-list-expenses>
          </div>
        </div>

        <div class="row" *ngIf="!readOnly">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-left btn btn-outline"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>